import articleDetailPageLoad from "~/store/graphql/queries/articleDetailPageLoad.graphql";

import runGraphQLQuery, {
  lastQuery,
} from "~/store/manage/utilities/runGraphQLQuery";

const loadArticleDetails = async function (
  { commit },
  { params, req, res, saveLastGraphQL }
) {
  commit("START_LOADING");

  const data = await runGraphQLQuery(
    articleDetailPageLoad,
    params,
    this.$axios,
    req,
    res
  );

  if (saveLastGraphQL === true) {
    commit("SET_LAST_GRAPHQL", lastQuery());
  }

  commit("SET_ARTICLE_DETAILS", data);
  commit("END_LOADING");

  return Promise.resolve(data);
};

export default loadArticleDetails;
